import { SVGProps, Ref, forwardRef } from 'react';

export const ArrowRightOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m9 14-.99-.99 4.31-4.31H1V7.3h11.32L8.01 2.99 9 2l6 6z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ArrowRightOutlinedSize16Glyph.displayName = 'ArrowRightOutlinedSize16Glyph';
